<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-01 11:20:33
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-21 11:46:39
-->
<template>
	<div class="flex-row">
		<!--动态生成sideItem-->
		<div
			class="side-item font-h4-regular"
			:class="checkIsActive(item.path)"
			v-for="item in menus"
			:key="item.path"
			@click="menuClickHandle(item.path)"
		>
			<span>{{ item.meta.title }}</span>
			<div class="pos-abso new-icon" v-if="newUrl.includes(item.path)">
				<i class="i-new"></i>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import * as types from '@/store/mutation-types';
export default {
	data() {
		return {
			menus: [],
			newUrl: ['/cooperativeShop'],
		};
	},
	mounted() {
		this.createMenu();
		this.setSubMenuList(this.$route.matched.map(item => item.path));
	},
	computed: {
		...mapState(['vuex_menuList']),
		activePath() {
			const matchedPath = [...this.$route.matched];
			const path = matchedPath.map(item => item.path);
			return path;
		},
	},
	created() {},
	watch: {
		activePath(val) {
			this.setSubMenuList(val);
		},
		vuex_menuList() {
			this.createMenu();
			this.setSubMenuList(this.$route.matched.map(item => item.path));
		},
	},
	methods: {
		createMenu() {
			// 只展示一级菜单为visible的菜单
			this.menus = this.vuex_menuList.filter(item => item.visible);
		},
		menuClickHandle(path) {
			if (this.activePath.includes(path)) {
				return;
			}
			this.$router.push(path);
		},
		checkIsActive(path) {
			return this.activePath.includes(path) ? 'active' : '';
		},
		setSubMenuList(activePath) {
			let sub_menu = this.vuex_menuList.find(item => activePath.includes(item.path))?.children.filter(item => item.visible);
			this.$store.commit(types.SUB_MEUNS_LIST, sub_menu);
		},
	},
};
</script>
<style lang="less" scoped>
.side-item {
	font-family: PingFang SC;
	position: relative;
	padding: 22px 14px;
	font-size: 14px;
	color: @color-text-primary;
	font-weight: 400;
	cursor: pointer;
	&:hover {
		color: @color-primary;
	}
	&.active {
		color: @color-primary;
		font-weight: 500;
	}
	&.active:after {
		content: '';
		height: 3px;
		background-color: @color-primary;
		width: 16px;
		position: absolute;
		bottom: 3px;
		left: 50%;
		margin-left: -8px;
		border-radius: 3px;
	}
	.new-icon {
		top: 10px;
		right: -14px;
	}
}
</style>
